export default {
  loginView: {
    yourName: 'Your name',
    yourEmail: 'Your email',
    yourPassword: 'Your password',
    yourNewPassword: 'Your new password',
    repeatYourPassword: 'Repeat your password',
    repeatYourNewPassword: 'Repeat your new password',
    requestAccess: 'New to $t(common.appNameFull)? Request access',
    resetPassword: 'Reset password',
    login: 'Login',
    loginUsingBackupCode: 'Login using 2FA backup code',
    forgotPassword: 'Forgot password',
    sendPasswordResetEmail: 'Send password reset email',
    twoFactorBackupCode: '2FA backup code',
    twoFactorToken: 'Verification code',
    twoFactorTokenDescription: `To keep your account secure, we verify your identity.

Enter the code generated by your authenticator app.`,
  },
  accessRequestView: {
    error: 'Error requesting access: {{error}}',
    fields: {
      email: '$t(common.email)',
      props: {
        firstName: 'First Name',
        lastName: 'Last Name',
        institution: 'Institution',
        country: 'Country',
        purpose: 'What do you need it for?',
        surveyName: 'Propose a Survey Name',
        templateUuid: 'Start from a template?',
      },
    },
    introduction: `Our resources are limited, so you have to request access to the platform.
We are also interested in what you want to do with it so please let us know!
You have the possibility to start from a **new blank survey** or clone an existing **template** and you will have to suggest a name for the newly created survey.
You will be assigned the role of ***Survey Administrator*** for that survey: you will be able to edit it and to invite new users to join your survey and contribute to it.
You will be also a ***Survey Manager*** and you will be able to **create new surveys** (up to 5) if needed.
For more information please visit our website: $t(links.openforisArenaWebsite)
$t(common.raiseTicketInSupportForum)
**Once you send the request, please wait for an invitation email to access Arena.**`,
    reCaptchaNotAnswered: 'ReCaptcha not answered',
    requestSent: 'Access Request sent correctly',
    requestSentMessage: `$t(common.emailSentToSelfConfirmation)
$t(guest:accessRequestView.whitelistSenderSuggestion)

Please give us a couple of days to process your request.
We will send you another email to **{{email}}** with the instructions on how to access $t(common.appName), once it's accepted.
Thank you and enjoy **$t(common.appNameFull)**!`,
    sendRequest: 'Send Request',
    sendRequestConfirm: 'Request access to $t(common.appNameFull)?',
    templateNotSelected: 'Not selected (start from scratch)',
    title: 'Requesting access to $t(common.appNameFull)',
    whitelistSenderSuggestion: `If you find it in the Spam/Junk folder, please add **{{senderEmail}}** to your contacts (address book) or mark it as safe/not spam, so that future emails from us reach your inbox directly.`,
  },
  resetPasswordView: {
    title: {
      completeRegistration: 'Complete your registration to Arena',
      setYourNewPassword: 'Set your new password',
    },
    setNewPassword: 'Set new password',
    forgotPasswordLinkInvalid: 'The page you have tried to access does not exist or is no longer valid',
    passwordSuccessfullyReset: 'Your password has been successfully reset',
    passwordStrengthChecksTitle: 'Password strength checks',
    passwordStrengthChecks: {
      noWhiteSpaces: 'No white spaces',
      atLeast8CharactersLong: 'At least 8 characters long',
      containsLowerCaseLetters: 'Contains lowercase letters',
      containsUpperCaseLetters: 'Contains uppercase letters',
      containsNumbers: 'Contains numbers',
    },
    completeRegistration: 'Complete registration',
  },
}
